import React from 'react';
import { cn } from '../lib/utils';

export const TrafficLight = ({ status, size = 'md', showLabel = false }) => {
  const sizeClasses = {
    sm: 'w-2.5 h-2.5',
    md: 'w-3 h-3',
    lg: 'w-4 h-4',
  };

  const colorClasses = {
    green: 'bg-emerald-500',
    yellow: 'bg-amber-400',
    red: 'bg-rose-500',
  };

  const labelMap = {
    green: 'Creciendo',
    yellow: 'Potencial',
    red: 'En riesgo',
  };

  return (
    <div className="flex items-center gap-2">
      <div
        className={cn(
          'rounded-full',
          sizeClasses[size],
          colorClasses[status] || 'bg-slate-400'
        )}
        data-testid={`traffic-light-${status}`}
      />
      {showLabel && (
        <span className="text-xs text-slate-600">{labelMap[status] || status}</span>
      )}
    </div>
  );
};
